export const flowCouponZH = {
  flowCoupon1: '我的优惠券',
  flowCoupon2: '元',
  flowCoupon3: '去使用',
  flowCoupon4: '还未报名此活动，请先前往报名~',
  flowCoupon5: '适用于',
  flowCoupon6: '可与早鸟叠加使用',
  flowCoupon7: '适用于平台活动',
  flowCoupon8: '暂无优惠券哦~',
  flowCoupon9: '还未报名此活动，请先前往报名~',
  flowCoupon10: '选择商品',
  flowCoupon11: '使用',
  flowCoupon12: '未使用',
  flowCoupon13: '已使用',
  flowCoupon14: '已失效',
  flowCoupon15: '优惠券还未到使用日期哦~',
  flowCoupon16: '暂无商品可使用~',
  flowCoupon17: '缴费还未开始哦~',
  flowCoupon18: '缴费已结束！',
  flowCoupon19: '联名计划',
  flowCoupon20: '有效期至',
  flowCoupon21: '立即领取',
  flowCoupon22: '平台通用券'
}

export const flowCouponEN = {
  flowCoupon1: 'My Coupons',
  flowCoupon2: 'RMB',
  flowCoupon3: 'To use',
  flowCoupon4: 'You have not registered for this activity, please go to register~',
  flowCoupon5: 'Suitable for ',
  flowCoupon6: 'can be stacked with early bird',
  flowCoupon7: 'Applicable to Platform activities',
  flowCoupon8: 'There are no coupons yet~',
  flowCoupon9: `You haven't registered for this activity yet, please go to register first~`,
  flowCoupon10: 'Select a product',
  flowCoupon11: 'Use',
  flowCoupon12: 'Unused',
  flowCoupon13: 'Used',
  flowCoupon14: 'Expired',
  flowCoupon15: 'The coupon has not yet reached the expiration date~',
  flowCoupon16: 'There are no products available for use at the moment~',
  flowCoupon17: 'The payment has not started yet~',
  flowCoupon18: 'Payment is now closed!',
  flowCoupon19: 'Collaboration plan',
  flowCoupon20: 'Expiration date',
  flowCoupon21: 'Claim now',
  flowCoupon22: 'Platform Common Coupon'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/coupon.js